import React from "react";
import FunFactCard from "./FunFactCard";
import { funFacts } from "../../data/funFacts";

const FunFact = () => {
  return (
    <div className="px-0 grid grid-cols-2 md:grid-cols-4 gap-6 pb-10">
      {funFacts.map(({ icon, des }) => (
        <FunFactCard key={des} icon={icon} des={des} />
      ))}
    </div>
  );
};

export default FunFact;
